import { h, defineComponent, SetupContext, VNode } from 'vue';
import { Tooltip } from '@/ui/components/Tooltip';
import { featureExplanationIcon } from '@/ui/components/icon/icons';
import { toUpperCaseExceptSpecialChars } from '@/ui/helpers';

export interface PageTitleProps {
  text: string;
  classes?: string;
}

export const PageTitle = defineComponent<PageTitleProps>({
  name: 'PageTitle',
  props: {
    text: {
      type: String,
      required: false,
    },
    classes: {
      type: String,
      required: false,
    },
  },
  setup(props: PageTitleProps, context: SetupContext) {
    return function render(): VNode {
      return h(
        'h1',
        { class: `title ${props.classes ?? 'is-3'}` },
        props.text ? toUpperCaseExceptSpecialChars(props.text) : context.slots.default?.(),
      );
    };
  },
});

export function pageTitle(text: string, classes = '') {
  const props: PageTitleProps = { text, classes };
  return h(PageTitle, { props });
}

export function pageTitleTooltiped(title: string, tooltipText: string) {
  return h(PageTitle, {
    props: {
      classes: 'page-title-tooltiped',
      text: title,
    },
  }, [
    title,
    h(Tooltip, {
      props: {
        label: tooltipText,
        position: 'is-bottom',
        multilined: true,
      },
    }, [
      featureExplanationIcon(),
    ]),
  ]);
}
